module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-footer.d21ad0fb.png";